import React, { memo, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { ChevronLeft, ChevronRight } from "lucide-react";
import GameCard from '../GameCard/GameCard';
import { preloadImages } from '../LazyImage/LazyImage';

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;

const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 11px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const NavigationButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const LeftButton = styled(NavigationButton)`
  left: 10px;
`;

const RightButton = styled(NavigationButton)`
  right: 10px;
`;

const GameCarousel = memo(({ 
  games = [], 
  onGameClick, 
  scrollContainerRef, 
  onScrollLeft, 
  onScrollRight,
  canScrollLeft = false,
  canScrollRight = true,
  isMobileView = false,
  onImageLoad,
  onImageError
}) => {
  // Preload images for better performance
  useEffect(() => {
    if (games && games.length > 0) {
      const imageUrls = games.slice(0, 10).map(game => game.game_icon); // Preload first 10
      preloadImages(imageUrls, 3); // Load 3 at a time
    }
  }, [games]);

  const handleImageLoad = useCallback((gameId) => {
    onImageLoad?.(gameId);
  }, [onImageLoad]);

  const handleImageError = useCallback((gameId) => {
    onImageError?.(gameId);
  }, [onImageError]);

  return (
    <CarouselContainer>
      <ScrollContainer ref={scrollContainerRef}>
        {games.map((game, index) => (
          <GameCard
            key={game.id || index}
            game={game}
            index={index}
            onGameClick={onGameClick}
            onImageLoad={handleImageLoad}
            onImageError={handleImageError}
          />
        ))}
      </ScrollContainer>
{/*       
      {!isMobileView && (
        <>
          <LeftButton onClick={onScrollLeft} disabled={!canScrollLeft}>
            <ChevronLeft size={20} />
          </LeftButton>
          <RightButton onClick={onScrollRight} disabled={!canScrollRight}>
            <ChevronRight size={20} />
          </RightButton>
        </>
      )} */}
    </CarouselContainer>
  );
});

export default GameCarousel;
